/**
 * Action and mutation types for wordpress/account module
 */
const types = {
  URL: 'url',
  USERNAME: 'username',
  PASSWORD: 'password',
  GET_ID: 'getId',
  LOGIN: 'login',
  LOGOUT: 'logout'
}

export default types



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/account/types.js